import { AccountBalance, CurrencyRole } from '../state/AccountState'
import { CurrencyCode } from '../constants'

interface Balance {
	goldCoins: number
	bonusGoldCoins: number
	sweeps: number
	bonusSweeps: number
}

export function getActiveBalance(
	selectedCurrency: string,
	balances: AccountBalance[],
	returnFormatted: boolean = true,
): string {
	for (let i = 0; i < balances.length; i++) {
		const a = balances[i]
		if (a.currencyCode === selectedCurrency && a.role === 'MAIN') {
			if (returnFormatted) {
				return a.formattedBalance
			} else {
				return a.amount.toString()
			}
		}
	}
	return null
}

export function getBalance(balances: AccountBalance[]): Balance {
	return balances.reduce(
		(result, b) => {
			switch (b.currencyCode + b.role) {
				case CurrencyCode.GOLD_COINS + CurrencyRole.main:
					result.goldCoins = b.amount
					break
				case CurrencyCode.GOLD_COINS + CurrencyRole.bonus:
					result.bonusGoldCoins = b.amount
					break
				case CurrencyCode.SWEEPS + CurrencyRole.main:
					result.sweeps = b.amount
					break
				case CurrencyCode.SWEEPS + CurrencyRole.bonus:
					result.bonusSweeps = b.amount
			}
			return result
		},
		{
			goldCoins: 0,
			bonusGoldCoins: 0,
			sweeps: 0,
			bonusSweeps: 0,
		},
	)
}

export const negativeBalanceToZero = (balanceLabel: string): number => {
	const balance = Number.parseFloat(balanceLabel)
	if (Number.isFinite(balance) && balance >= 0) {
		return balance
	} else {
		return 0
	}
}

export const getBalanceLabel = (currencyCode: CurrencyCode, accountBalances: AccountBalance[]): string => {
	if (accountBalances.length === 0) return ''

	const activeBalance = getActiveBalance(currencyCode, accountBalances, false)
	if (activeBalance !== undefined) return activeBalance

	const balance: AccountBalance = accountBalances.find((ab: AccountBalance) => ab.role === CurrencyRole.main)

	return balance ? balance.formattedBalance : ''
}
